<template>
  <v-app class="whole">
    <div class="inside">
      <v-img src="./watch.jpg" :height="300" ></v-img>
      <div class="btnSpace_back display_desktop">
        <v-btn color="primary" x-large text @click="goback"><span class="material-icons">
          chevron_left</span>もどる</v-btn>
      </div>
    <div class="myform">
      <div class="title-spaced">
      </div>

      <div class="titleCompany">キャンセルについて</div>
      <div class="memoText">
          <p>当サイトでご購入頂いた後のキャンセルは、下記キャンセル料をご請求いたします。</p>
      </div>
      <div class="titleCompany">キャンセル料について</div>
      <div class="memoText">
          <p>ご注文のキャンセルをご希望の場合は、出荷状況をもとに以下のキャンセル事務手数料、キャンセル料をいただきます。</p>
          <p><b>キャンセル事務手数料　1,000円</b></p>
      </div>
      <div class="titleCompany">キャンセル料</div>
      <div class="memoText">
        <p><b>出荷準備開始前までのご注文 ： ご注文商品総額の50%</b></p>
        <p><b>出荷準備以降のご注文 ： ご注文商品総額の100%</b></p>
        <p>キャンセル料の総額に応じて、ご返金またはご請求のご連絡をさせていただきます。</p>
        <p>＜出荷後の商品をお受け取りにならず、キャンセル処理となった場合＞</p>
        <p>商品代金全額をキャンセル料として頂戴いたします。</p>
        <p>加えて、往復配送料と返品事務手数料として、2,500円をご請求いたします。</p>
        <p>ご注文キャンセル後にご連絡がとれない場合は、法的措置をとることがございます。</p>
        <p>予めご了承ください。</p>
      </div>
      <div class="titleCompany">商品の交換・返品</div>
      <div class="memoText">
        <p>弊社の手違いにより、商品に破損や汚損があった場合、返品または交換させて頂きます。</p>
        <p>但し、お客様のご都合により、問題の無い商品を返品・交換することは原則的に承っておりません。</p>
        <p>また、数に限りがある特典につきましては、特典の有無につき、保証いたしかねます。特典の種別に関わらず、特典がつかないことによる返品・交換も承っておりません。予めご了承ください。</p>
      </div>
      <div class="titleCompany">商品配送中の商品破損の場合</div>
      <div class="memoText">
        <p>商品配送中に、配送用段ボールの上から衝撃を受けて商品が破損・汚損した場合には、各配送業者で弁償、または代替品の手配を行います。</p>
        <p>お手数ですが、各配送会社お問い合わせ窓口までご連絡ください。</p>
        <p><b>ヤマト運輸お問い合わせ窓口：0120-01-9625</b></p>
      </div>
      <div class="titleCompany">品違い・初期不良品の場合</div>
      <div class="memoText">
        <p>お届けした商品がご注文と違う場合（品違い）、商品に瑕疵がある場合（初期不良品）の場合には、商品到着日より7日間以内のお問い合わせに限り不良品の返品・交換を承ります。</p>
        <p>当社所定の手続きにより、品違い品・初期不良品を弊社に返送頂いた後、確認次第、代替商品を発送させて頂きます。</p>
        <p>なお、上記返品にかかる送料は当社が負担致しますので「着払い」にてお送りください。</p>
        <p>元払いにてご発送頂いた場合、送料の返金・償還は致しかねますのでご了承ください。</p>
        <p>但し、ご注文された商品の在庫がない場合は、当社は消費税を含む商品の購入代金、取扱手数料、送料等の合計を返金致します。</p>
        <p>※ご注文者以外の方からのお申し出についてはご対応致しかねます。</p>
      </div>
    </div>
    </div>
  </v-app>
</template>

<script>
  export default {
    data() {
      return {
      }
    },
    computed:{
    },
    mounted() {
    },
    filters: {
    },
    methods: {
      goback() {
        this.$router.go(-1)
      },
    },
  }
</script>
<style scoped>
  .whole {
      background-color: rgba(218, 218, 219, 0.2);
      color:#555555;
    }
    .inside {
      margin: 10%;
      padding: 0 0 0% 0;
      background-color: white;
      height: 100%;
    }
    @media screen and (min-width:896px){
        .inside {
          margin: 1% 10%;
        }
      }
  .myform{
   background-color: white;
    width: 80%;
    margin: 3% auto;
  }
  @media screen and (max-width:480px){
  /*画面幅が480pxまでの時*/
    .myform{
      width: 100%;
    }
  }
  /* @media screen and (min-width:781px){ */
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .myform{
      width: 70%;
    }
  }
  
  .mtb-medium{
    margin: 5% 0%;
  }
  .mb{
    margin-bottom: 3%
  }
  .b-form-group {
    margin: 15% 0%;
    padding: 15% 0%;
  }
  .btnSpace{
    width: 50%;
    margin: 10% auto;
  }
  @media screen and (min-width:896px){
    /*画面幅が781px以上の時*/
    .btnSpace{
      width: 30%;
      margin: 15% auto;
    }
  }
  .form-spaced{
    padding: 0% 0;
  }
  .title-spaced{
    padding: 0% 0;
  }
  .alert-spaced{
    padding: 3% 0 0 0;
    /* margin: 5% 0; */
  }
  .question_spaced{
    padding: 7% 0;
  }
  .question_inside_spaced{
    padding: 4% 0;
  }
  .spinbtn-spaced{
    padding: 0 5%;
  }
  .v-btn{
    text-decoration: none;
  }
  .stepper-text {
    color:#555555;
    font-size: 0.8rem;
  }
  .stepper-text-option {
    color:white;
    font-size: 0.6rem;
    padding: 7% 0;
  }
  .tableSpace {
    margin: 1% 0 7% 0;
  }
  .spinbtn-spaced{
    width: 60%;
    padding: 0 0% 0 0 ;
  }
  .inputForm_spaced {
    margin: 5% 10% 5% 0;
    text-align: left;
    color:#555555;
  }
  .formSpace2 {
    margin: 3% 0 0 0;
  }
  .titleCompany {
    font-size: 1.5rem;
    border-left: solid 7px #3c45bd;
    padding: 0 0  0 3% ;
  }
  .btnSet2 {
    margin: 15% 0;
    text-align: center;
    padding: 0 30%;
  }
  .btnText {
    margin: 0 0 0 10%;
  }
  .formNum {
    padding: 0 5% 0 0 ;
  }
  .tableSpace_sum {
    margin: 0 0 0 60%;
  }
  .infoSpace {
    margin: 7% 0;
  }
  .totalPrice {
    font-size: 1.6rem;
    font-weight: 500;
  }
  .memoText {
    margin: 2% 5% 5% 5% ;
  }
</style>